import Menu from './Menu';
import {$body} from '../Constants';

/**
 * Implementation of Menu for MetaMenu Navigation
 */
class MetaMenu extends Menu {
    onReady() {
        this.adjustLineHeight();
    }

    onResize() {
        this.adjustLineHeight();
    }

    adjustLineHeight() {
        this.$element.find('ul.level-1 > li').each(function() {
            $(this).find('> a, > label').css('line-height', $(this).height() - 2 + 'px');
        });
    }
}

export default (new MetaMenu($body.find('.menuMeta')));